<template>
  <section style="" class="about w-100 row m-0 justify-content-center p-5 flex-row-reverse  mt-2  shadow">
    <div class="col-8 col-md-4 col-lg-3 d-inline-block text-center">
      <img class="" src="image/learn.png" width="100%" alt="">
    </div>
    <div class="col-10 col-md-8 col-lg-6 d-inline-block">
      <h3> درباره تهران آیلتس</h3>

      <p style="text-align: justify">
        آموزشگاه تهران آیلتس در سال 90 بازگشایی شد و باارائه روشهای نوین آموزشی، در سال 96 رتبه اول در تهران را
        بدست آورد. این آموزشگاه شعبه دیگری ندارد و با توجه به امکاناتی از قبیل اموزش آنلاین و دوره های ویدئویی
        زبان آموزان زیادی را سطح کشور داشته و پیوسته میکوشد تا بهترین تنایج را در ازمون ایلتس برای زبان اموزان
        عزیز رقم بزند.
      </p>
      <!--            <p style = "text-align: justify">-->
      <!--              حتمن شده کلی دنبال یه دوره تخصصی بگردی و چیزی که میخوای رو پیدا نکنی. یا کلاسی که پیدا میکنی تو شهرتون-->
      <!--              نباشه-->
      <!--              یا زمانبندیش با برنامه ت جور نباشه. حتمن شده کلی هزینه کنی ولی اون چیزی که میخواستی رو یاد نگیری. شاید اصن-->
      <!--              تو-->
      <!--              شهرتون کلاسی که میخوای نیست، یا هست، تو حالشو یا وقتشو نداری که بری کلاس و دوس داری از تو خونه یاد بگیری.-->
      <!--              اینجا همه اینا هست به اضافه خیلی چیزای دیگه! حتی دوره رایگان هم داریم!دیگه وقتشه متخصص شی، پس بدو ثبت نام-->
      <!--              کن!-->
      <!--              <br>-->
      <!--              حتی اگه میخوای دوره آموزشی خودتو معرفی کنی باما تماس بگیر تا اونو به همه دنیِــا نشون بدیم!-->
      <!--            </p>-->
      <!--            <button class="btn btn-light ">تلفن</button>-->
      <!--            <button class="btn btn-light">ایمیل</button>-->
      <!--            <button class="btn btn-light">ملاقات</button>-->

    </div>
  </section>

</template>

<script>
export default {
  name: "TheAbout"
}
</script>

<style scoped>

</style>